'use strict';

import Constants from '../constants';
import ObjectAssign from 'object-assign';
import ParseValidation from '../../../../helpers/parse-validation';


const initialState = {
    show: false,
    loading: false,
    error: undefined,
    hasError: {},
    help: {}
};
const reducer = function (state = initialState, action) {

    if (action.type === Constants.CREATE_NEW_TOS_AGREED) {
        return ObjectAssign({}, state, {
            loading: true
        });
    }

    if (action.type === Constants.CREATE_NEW_TOS_AGREED_RESPONSE) {
        const validation = ParseValidation(action.response);

        return ObjectAssign({}, state, {
            loading: false,
            error: validation.error,
            hasError: validation.hasError,
            help: validation.help
        });
    }

    return state;
};


export default reducer;
